import React, { Component } from 'react';
import * as Media from '../../utils/Breakpoints';



class ImageComponent extends Component {

  loading=0;
  timer=0;

	constructor(props) {
    super(props);
    this.state = {width:0,loaded:0};
  }

  componentDidMount() {

      let lazy = 1;
      if(this.props.hasOwnProperty('lazy') && (this.props.lazy === false)) lazy = 0;
      let loaded = (lazy) ? 0 : 1;

      this.setState({lazy:lazy,visible:false,width:this.refs.image.offsetWidth,loaded:loaded,height:this.refs.image.offsetHeight});
      if(!loaded){
        setTimeout(this.listen,50);
        this.startListener();
      }

	}

	componentWillUnmount() {
      this.stopListener();
	  }


    startListener = () => {

        this.timer = setInterval(this.listen,1000);

    }
    load = (src) => {

        if(this.loading) return;

        this.loading = 1;
        let i = new Image();
        let _this = this;
       
        i.onload = function(){
          
          _this.setState({loaded:1});

        }

        i.src = src;

    }

    stopListener = () => {

        clearInterval(this.timer);

    }

    listen = () => {

        if(!this.refs.image) return;
        
        let threshold = window.innerHeight; // Precision for how close to viewport bounds is deemed 'visible'

        let wasVisible = this.state.visible;


        // Is visible?
       let offset = this.refs.image.getBoundingClientRect();
       let imageHeight = Math.abs(offset.top - offset.bottom);
       let imageWidth = Math.abs(offset.left - offset.right);

       let topVisible = (offset.top < (window.innerHeight + threshold));
       let bottomVisible = (offset.bottom > (-threshold));

       let leftVisible = (offset.left < (window.innerWidth + threshold));
       let rightVisible = (offset.right > (-threshold));


       let largerThanViewport = ((offset.top < 0)&& (offset.bottom > window.innerHeight));

        let isVisible = (offset.width > 0) && ((topVisible && bottomVisible && leftVisible && rightVisible) || largerThanViewport);

      if((isVisible && !wasVisible) || (offset.width != this.state.width) || (offset.height != this.state.height) ) this.setState({visible:(isVisible||wasVisible),width:offset.width,height:offset.height});



    }


  render() {


	const ratioStyle = {

  		paddingTop:(100 / (this.props.ratio))+'%'

  	}
  	const fluidStyle = {

  		width:'100%',
  		height:'100%',
      position:'absolute',
      top:0,
      left:0

  	}

  	const style = (this.props.fluid) ? fluidStyle : ratioStyle;

    let className = this.props.className || '';

    if(this.props.fluid) className += " Image--fluid";

    if(this.state.visible) className += " Image--visible";

    if(this.state.loaded) className += " Image--loaded";

    if(this.props.orientation) className += " Image--orientation-"+this.props.orientation;

    if(this.state.lazy) className += " Image--lazy";

    const fallback = this.props.large || this.props.small || this.props.src;
    const small = (this.props.small) ? this.props.small : this.props.src;
    const medium = (this.props.medium) ? this.props.medium : this.props.src;
    const large = (this.props.large) ? this.props.large : this.props.src;

    
    if(this.state.lazy && (!this.refs.image || !this.state.visible || !this.state.width )) return <div className={'Image '+className} ref="image" style={style}><div className="Image-media" title={this.props.title} /></div>

    // Is the image being displaed at a rtio outside of its natural prortions? If so, recalculate therequired size
    let scale = (this.props.ratio / (this.state.width/this.state.height) );
    scale = (isNaN(scale) || scale < 1) ? 1 : scale; 
    
    let w = this.state.width * window.devicePixelRatio * scale;

    let size = 'large';

    let src;

    src = large;
    if(w < 1000) src = medium;
    if(w < 600) src = small;
    


    if(!src) src = fallback;

    if(w < 1000) size = 'medium'
    if(w < 600) size = 'small';

    //console.log(this.props.svg)

    if(this.props.svg) src = this.props.svg 


    if(this.state.lazy && !this.state.loaded){
      this.load(src);
      return <div className={'Image Image--loading '+className} ref="image" style={style}><div className="Image-media" title={this.props.title} /></div>
    }

    return (
      <div className={'Image '+className} ref="image" style={style} data-width={w} data-scale={scale}>

 		       <div className="Image-media" style={{backgroundImage:"url("+src+")"}} title={this.props.title} />
 		   
      </div>
    );
  }
}

export default ImageComponent;



// WEBPACK FOOTER //
// ./src/js/_core/components/Image/Image.jsx